import React, { useEffect, useState } from 'react';
import BannerSection from '../sections/banner-section';
import BannerEditModal from './modals/banner-edit-modal';
import { getData } from '@/services/api.service';
import IntroSection from '../sections/intro-section';
import IntroEditModal from './modals/intro-edit-modal';
import HighlightSection from '../sections/highlight-section';
import HighlightEditModal from './modals/highlight-edit-modal';
import ServiceSection from '../sections/services-section';
import ServiceEditModal from './modals/service-edit-modal';
import TestimonialSection from '../sections/testimonial-section';
import TestimonialEditModal from './modals/testimonial-edit-modal';
import MobileAppSection from '../sections/mobile-app-section';
import MobileAppEditModal from './modals/mobile-app-edit-modal';
import Header2 from '@/feature-module/common/header/header-2';
import Header2Edit from '@/feature-module/common/header/edit/modals/header2-edit-modal';
import Header2EditModal from '@/feature-module/common/header/edit/modals/header2-edit-modal';

const Home2Edit = ({ themeData, fetchData }: any) => {
  return (
    <>
      {/* <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#headerEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <>
          <Header2 themeData={themeData} />
        </>
      </div> */}
      {/* <div
        className="modal fade"
        id="headerEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <Header2EditModal themeData={themeData} fetchData={fetchData} />
      </div> */}

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#sectionBannerEditmodal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <BannerSection themeData={themeData} />
      </div>
      <div
        className="modal fade"
        id="sectionBannerEditmodal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <BannerEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#introSectionEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <IntroSection themeData={themeData} />
      </div>
      <div
        className="modal fade"
        id="introSectionEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <IntroEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#highlightSectionEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <HighlightSection themeData={themeData} />
      </div>
      <div
        className="modal fade"
        id="highlightSectionEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <HighlightEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#serviceEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <ServiceSection themeData={themeData} />
      </div>
      <div
        className="modal fade"
        id="serviceEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <ServiceEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#testimonialEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <TestimonialSection themeData={themeData} />
      </div>
      <div
        className="modal fade"
        id="testimonialEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <TestimonialEditModal themeData={themeData} getThemeData={fetchData} />
      </div>

      <div className="section-editor">
        <a
          data-bs-toggle="modal"
          data-bs-target="#mobileAppEditModal"
          className="section-editor-icon"
        >
          <i className="fas fa-edit"></i>
        </a>
        <MobileAppSection themeData={themeData} />
      </div>
      <div
        className="modal fade"
        id="mobileAppEditModal"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <MobileAppEditModal themeData={themeData} getThemeData={fetchData} />
      </div>
    </>
  );
};

export default Home2Edit;
